import React, { Component } from 'react';

import VirtualizedList from '../VirtualizedList';
import { appsPerPage } from 'config';
import App from '../../../models/app';
import { AppListItem } from './AppListItem';

interface AppDigestProps {
  onRemove?: () => void;
  showInstalled?: boolean;
  showUpdate?: boolean;
  showSettings?: boolean;
}

interface VirtualizedAppListProps {
  apps: App[];
  hasNextPage: boolean;
  appDigestProps?: AppDigestProps;
  fetchMore: any;
  navbarHeight: number;
  collectionId?: string;
}

export class VirtualizedAppList extends Component<VirtualizedAppListProps> {
  isItemLoaded = ({ index }: { index: number }) => {
    const { apps } = this.props;
    return !!apps[index];
  };

  render() {
    const { apps, hasNextPage, appDigestProps, fetchMore, navbarHeight, collectionId } = this.props;

    const appsCount = apps.length;

    return (
      <VirtualizedList
        isApp={true}
        currentCount={appsCount}
        maxCount={!hasNextPage ? appsCount : undefined}
        pageSize={appsPerPage}
        pageLoadThreshold={8}
        isItemLoaded={this.isItemLoaded}
        fetchMore={fetchMore}
        navbarHeight={navbarHeight}
      >
        {({ index }: any) => (
          <AppListItem app={apps[index]} collectionId={collectionId} {...appDigestProps} />
        )}
      </VirtualizedList>
    );
  }
}
